/** @jsx jsx */
import { Component } from 'react'
import { jsx } from '@emotion/core'
import Select from 'react-select'

import FormError from './FormError'
import FormWarning from './FormWarning'

class Dropdown extends Component {
    render() {
        const {
            extra_class,
            placeholder,
            input,
            label,
            tabIndex,
            meta,
            options,
            ...extraProps
        } = this.props
        
        return (
            <div>
              <Select
                  {...extraProps}
                  value={input.value}
                  options={options}
                  onChange={(value) => input.onChange(value)}
                  css={ extra_class }
              />
              { meta.error && meta.touched ?
                <FormError meta={ meta } />
                :
                <FormWarning meta={ meta } />
              }
            </div>
        )
    }
}
export default Dropdown
